import { Box, makeStyles } from "@material-ui/core";
import { ResetForm } from "pages/VisitPage/Forms/ResetForm";
const ResetPage = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.authBox}>
        <ResetForm />
      </Box>
    </Box>
  );
};

export default ResetPage;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    minHeight: "100vh",
    height: "100%",
  },
  authBox: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "@media (max-width: 900px)": {
    authBox: {
      width: 400,
    },
  },
}));
